import { utilHelper } from "../../_helpers";

const relativeUrl = 'api/wishlist'

export const wishlistService = {
    search,
    saveItem,
    updateItem,
    deleteItem,
    add,
    remove,
    totals
};


//search
function search(offset, max, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: data, showAlert:false })
}

//save
function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data });
}

//update
function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data: data });
}

//delete
function deleteItem(id, fbDB) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${fbDB}`, 'DELETE',{})
}

function add(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/add`, 'POST', { data: data });
}

function remove(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/remove`, 'POST', { data: data });
}

function totals(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/totals?max=${max}&offset=${offset}`, 'POST', { data: data, showAlert:false });
}
